import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { IllustrationComponent, PageComponent, TertiaryButtonComponent } from '@ftr/foundation'
import { AppPaths, HOME_ROUTE, NAVIGATION_SHELL } from '@ftr/routing-paths'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'

@Component({
  selector: 'ftr-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule, IllustrationComponent, PageComponent, TertiaryButtonComponent],
})
export class NotFoundComponent {
  private readonly homeRoute = inject(HOME_ROUTE)
  protected readonly navigationShell = inject(NAVIGATION_SHELL)
  private readonly router = inject(Router)
  private readonly store = inject(Store)

  homeHref(): string {
    if (this.homeRoute() === 'root') {
      return '/'
    }
    const courtSystemId = this.store.selectSnapshot(UserState.currentCourtSystem)?.id
    return courtSystemId ? `/${AppPaths.CourtSystem}/${courtSystemId}` : `/${AppPaths.CourtSystem}`
  }

  goToHome(): void {
    void this.router.navigateByUrl(this.homeHref())
  }
}
